<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Manage Promotion</span>
        </div>
    </div>
    <div class="card card_content">
        <div class="row d-flex  align-items-center flex-wrap grid-margin mb-3">
            <div class="col-md-4">
                <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
                    <i class="fa fa-refresh"></i> Refresh
                </button> -->
                <app-button (refreshClicked)="clearFilter()"></app-button>

                <button type="button" class="btn btn-primary text-nowrap" (click)="goToManagePromotionAdd(0,0)">
                    <i class="fa fa-plus"></i> Add
                </button>
            </div>
            <div class="col-md-4 padd-right-file" style="display: flex;">
                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
                    <mat-label>Search</mat-label>
                    <div class="search-input-container">
                        <input placeholder="Enter Promo Code / Promo Name" id="search" matInput
                            (keydown.enter)="getTableData()" (keyup)="applyFilter($event)" type="text" #searchInput
                            (keydown.space)="preventLeadingSpace($event)">
                    </div>
                </mat-form-field>
                <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                    (click)="getTableData()">
                    <mat-icon style="color: white;">search</mat-icon>
                </button>
            </div>


        </div>

        <div class="table-responsive mt-2 mb-4">
            <mat-table #table [dataSource]="dataSource">

                <ng-container matColumnDef="PromoName">
                    <mat-header-cell *matHeaderCellDef>Promo Name</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.promoName}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="PromCode">
                    <mat-header-cell *matHeaderCellDef>Promo Code</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.promoCode}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="providerName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="providerName">Service Provider</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.providerName}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="StartDate">
                    <mat-header-cell *matHeaderCellDef>Promo Start Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.promoStartDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="EndDate">
                    <mat-header-cell *matHeaderCellDef>Promo End Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.promoEndDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="promovalidity">
                    <mat-header-cell *matHeaderCellDef>Promo Validity</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.promotionValidity > 1? dataField.promotionValidity
                            + ' Months': dataField.promotionValidity + ' Month'}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="promoStatus">
                    <mat-header-cell *matHeaderCellDef>Promo Status</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign status-badge"
                            [ngClass]="dataField.isPromoActive == true ? 'status-active' : 'status-inactive'">
                            {{dataField.isPromoActive == true ? 'Active' : 'Inactive'}}
                        </p>
                    </mat-cell>
                </ng-container>


                <ng-container matColumnDef="Action">
                    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <div class="text-truncate text-center">
                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-edit mr-3"
                                title="Edit Promotion" (click)="goToManagePromotionAdd(dataField.id,1)"></i>
                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-eye mr-3"
                                title="View Promotion" (click)="goToManagePromotionAdd(dataField.id,2)"></i>
                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-trash-can"
                                title="Delete Promotion" (click)="deleteUser(dataField)"></i>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
            <div *ngIf="data.length == 0" class="no-data-message">
                <p>No data found</p>
            </div>
        </div>


        <div class="table_pagenation">
            <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
                [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>